import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import { MultiSelect } from 'react-multi-select-component';
import ErrorMessage from '../../../../ErrorMessage';
import ContactService from '../../../../../Services/contactService';

export default class ContactMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    onChange: () => alert('ContactMultiChoice Onchange'),
    selected: [],
    fieldName: '',
    idFilter: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    ContactService.GetContactListByClientId(this.props.idFilter, true)
      .then((result) => {
        const optValues = [];
        const selected = [];
        result.forEach((contact) => {
          const newValue = {
            label: `${contact.name} (${contact.contactId})`,
            value: contact.contactId,
          };
          optValues.push(newValue);

          if (this.props.selected && this.props.selected.some((x) => x.toString() == contact.contactId.toString())) {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected,
        });
      })
      .catch((error) => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('SMC67');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected.map((i) => i.value.toString()));
  }

  renderList() {
    return (
      <MultiSelect
        options={this.state.itemList}
        value={this.state.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className={'text-center arial w-100 text-center hover rounded arial m-1 p-1'}>
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
